import React from 'react';
import { Box, Typography, Card } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import { SubcontractorForm } from '../../components/subcontractors';

export const SubcontractorCreatePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3, maxWidth: '1200px', mx: 'auto' }}>
      <Typography level="h2" sx={{ mb: 3 }}>
        Add New Subcontractor
      </Typography>
      <Card>
        <SubcontractorForm 
          onSuccess={(subcontractor) => {
            navigate(`/operations/subcontractors/${subcontractor.id}`);
          }}
          onCancel={() => navigate('/operations/subcontractors')}
        />
      </Card>
    </Box>
  );
};